module.exports = __webpack_public_path__ + "img/page-02.45c24724.png";